@if (performer) {
  <account-page title="{{ performer.first_name }} {{ performer.last_name }}">
    <tabs [tabs]="tabs"></tabs>
  </account-page>
}
